import {Component} from 'react'
import {toastr} from 'react-redux-toastr'
import {withRouter} from 'react-router-dom'
import { format } from 'date-fns'
import {createLocation} from 'history'
import connect from 'react-redux/es/connect/connect'

import OfferForm from '../../../../components/Forms/OfferForm/OfferForm.jsx'
import SubmitButton from '../../../../components/Forms/OfferForm/SubmitButton.jsx'
import {redirectToAccessDenied} from '../../../Errors/actions.js'
import api from '../../../../../api.js'
import {generate} from '../../../../routes.js'
import OfferLayout from '../OfferLayout/OfferLayout.jsx'
import {isAdmin} from '../../../../../shared/services/userService.js'
import {loadUniverseById} from '../../../../components/UniverseLoader/actions.js'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'

class OfferCreate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      offer: {
        universe: props.currentUniverseId,
        sub_universes: []
      }
    }
  }

  componentDidMount() {
    const userMainUniverseId = this.props?.currentUser?.mainUniverse ?? null
    const userUniverses = this.props?.currentUser?.universes?.length ? this.props?.currentUser?.universes : []
    if (!userUniverses.includes(this.props?.currentUniverseId) && userMainUniverseId !== null) {
      this.props.loadUniverseById(userMainUniverseId)
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if(prevProps.currentUniverseId !== this.props.currentUniverseId){
      this.setState({offer: {
        ...this.state.offer,
        universe: this.props.currentUniverseId
      }})
    }
    if (!this.props.isAdmin) {
      this.props.redirectToAccessDenied()
    }
  }

  submit = (data) => {
    const offer = this.props.flattenOffer(data.offer)

    const offerData = {
      ...offer,
      email: this.props.currentUser.email,
      publication_date: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
    }

    return api.offers.add(offerData)
  }

  onFormSuccess = (response) => {
    toastr.success('Votre annonce a été créée mais n\'est pas encore publiée')
    this.props.history.push(createLocation(
      generate({
        name: 'offers.details.edit',
        parameters: {
          offer: response?.data?.id
        }
      })
    ))
  }

  render() {
    return (
      <OfferLayout>
        <div className="p-2 p-md-5">
          <Loader visible={this.state.loading}>Chargement en cours</Loader>
          <OfferForm
            initialValues={{offer: this.state.offer}}
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
            enableReinitialize={true}
          />
          <SubmitButton className="btn btn-primary my-3">Créer</SubmitButton>
        </div>
      </OfferLayout>
    )
  }
}

export default connect(
  (state) => ({
    notFound: state.errors.notFound,
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  }),
  (dispatch) => ({
    loadUniverseById: (universeId) => dispatch(loadUniverseById(universeId)),
    redirectToAccessDenied: () => dispatch(redirectToAccessDenied),
  })
)(withRouter(OfferCreate))
